module.exports = __webpack_public_path__ + "img/未标题-1.2bba9f2f.jpg";